import { WorksheetField } from '../common/components/Field';
import { PropertyTaxTypeRadioOptions } from '~/constants';
import { InputType } from '~/schema';

export default function PricingEstimatePropertyTax () {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--medium)' }}>
      <WorksheetField
        type="radio"
        schemaKey="propertyTaxType"
        fieldLabel="Energy system property tax"
        helpText="Please note that some states have blanket exemptions; others have exemptions at certain size thresholds."
        values={PropertyTaxTypeRadioOptions}
        inline
        stretched
      />
      <WorksheetField
        type="number"
        schemaKey="propertyTaxAmount"
        numberType={InputType.DOLLARS}
      />
      <WorksheetField
        type="number"
        schemaKey="propertyTaxEscalator"
        numberType={InputType.PERCENT}
        decimals={2}
        width="half"
      />
    </div>
  );
}